import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/DispatcherLanding';

const DispatcherLandingPage = () => {
  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default DispatcherLandingPage;
